<template>
<!--- Card Start -->
        <div class="col-md-12 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
              <template v-slot:header>
                <div class="col-md-12" style="padding-left: 0px;">
                  <strong style="font-size: 140%"> Pargya AW40 Sampling</strong><br>
                    <small>by first cry march 13 2020 09:23 pm</small>
                </div>

              </template>

              <b-card-text>
                  <b-tabs>
            <b-tab title="ALL DESIGNS" active>
                <b-row>
      <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/13.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/14.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/15.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/13.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/16.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/13.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/14.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/15.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div class="col-md-4 " style="float: left;margin-bottom: 15px;" >
          <b-card-group deck >
            
            <b-card  header-tag="header" >
             

              <b-card-text>
                 <div style="width: 20%;float: left">
                   <img src="img/avatars/13.jpg" height="250" width="250" />
                  </div>
              </b-card-text>

             
              <template v-slot:footer>
               <span class="mb-0">Light blue top
               
                <b-col cols="6" sm="4" md="3" xl="2" style="float:right">
                  <span  @click="sampelAddModal = true"> <i class="cui-options icons font-2xl d-block mt-4"></i></span>
           
            
          </b-col>
                </span>
              </template>
            </b-card>
            

          </b-card-group>
        </div>
        <div>
        <b-button  color="danger" shape="pill" style="float:right;" variant="danger">ADD DESIGN</b-button>
      </div>
        <!--- Card End -->
    
    </b-row><!--/.row-->
            </b-tab>
            <b-tab title="DRAFTS" >
          <h1>the page is under construction</h1>

            </b-tab>
            <b-tab title="SAMPLING" >
   <h1>the page is under construction</h1>
    </b-row>
            </b-tab>
            <b-tab title="PRODUCTION" >
              <h1>the page is under construction</h1>
            </b-tab>
      


           
        </b-tabs>
                

               

                     

               
              </b-card-text>

             
              
            </b-card>
            

          </b-card-group>
        </div>
        <!--- Card End -->

</template>

<script>
export default {
  name: 'Tabs',
  data () {
    return {
      tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],
      activeTab: 1
    }
  }
}
</script>
<style>
  .short-div {
  height:55px;
}
</style>
